import { render, staticRenderFns } from "./NewCheckout.vue?vue&type=template&id=876fb2e0"
import script from "./NewCheckout.vue?vue&type=script&lang=js"
export * from "./NewCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports